// The account is playing in another window (server/tabs.ts): this one waits
// behind a screen with a single "Play here" that takes over.
let el: HTMLElement | null = null;

export function showElsewhere(playHere: () => void) {
  if (el) return;
  el = document.createElement('div');
  el.className = 'scrim elsewhere';
  el.style.background = 'rgba(6, 8, 13, .92)';
  el.style.zIndex = '200';
  el.innerHTML = `<div class="dialog" role="dialog" aria-modal="true" aria-labelledby="elsewhere-title" style="width:360px;text-align:center">
    <h3 id="elsewhere-title">Playing in another window</h3>
    <div class="actions" style="justify-content:center;border-top:0"><button class="btn primary" type="button">Play here</button></div></div>`;
  const btn = el.querySelector('button')!;
  btn.addEventListener('click', () => { btn.disabled = true; playHere(); });
  document.body.appendChild(el);
  btn.focus();
}

export function hideElsewhere() { el?.remove(); el = null; }
